module.exports = __webpack_public_path__ + "assets/img/mecha-btn-c79bfb28.png";